import React, { useContext, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MemberContext } from "../../Contexts/MemberContext";
import { getResponsiveColumns } from "../../utils/responsiveColumns";
import { fillDummyItems } from "../../utils/fillDummyItems";
import { useFirestoreOrderedList } from "../hooks/useFirestoreOrderedList";
import MarkdownPreview from "./MarkdownPreview";
import "./CommonIntroduction.scss";
import "./CommonIntroduction.theme.scss";
import "./CommonIntroduction.modifier.scss";

const CommonIntroductionBase = ({
  slide,
  collectionName,
  postTitle,
  targetItems,
  enableMarkdown = false,
  linkMode = "detail", // "detail" | "external"
}) => {
  const { currentUserInfo } = useContext(MemberContext);
  const isAdmin = currentUserInfo?.administrator === true;
  const navigate = useNavigate();

  const dataList = useFirestoreOrderedList(collectionName);
  const [columns, setColumns] = useState(null);

  /* responsive */
  useEffect(() => {
    const resize = () => setColumns(getResponsiveColumns(window.innerWidth));
    resize();
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  const adjustedArray = useMemo(() => {
    if (!columns || !dataList.length) return [];
    return fillDummyItems(dataList, columns);
  }, [dataList, columns]);

  if (!columns) return null;

  return (
    <div className="commonintroduction-container">
      <video
        autoPlay
        loop
        muted
        className="commonintroduction-container-background-video"
      >
        <source src="/videos/background.mp4" type="video/mp4" />
      </video>

      <div className="commonintroduction-content">
        <div className="commonintroduction-title">
          <div className="commonintroduction-titletext">
            {slide.split("").map((c, i) => (
              <span
                key={i}
                className="commonintroduction-title-char"
                style={{ "--char-index": i }}
              >
                {c}
              </span>
            ))}
          </div>

          {isAdmin && (
            <div
              className="commonintroduction-post"
              onClick={() =>
                navigate("/firestoreservice", {
                  state: {
                    posttitle: postTitle,
                    databasename: collectionName,
                    targetitems: targetItems,
                  },
                })
              }
            >
              <span className="commonintroduction-post-text">追 加</span>
            </div>
          )}
        </div>

        <div className="commonintroduction-box-wrap">
          {adjustedArray.map((item, i) => (
            <div
              key={i}
              className={`commonintroduction-box ${
                item.isDummy ? "dummy" : ""
              }`}
            >
              {!item.isDummy && (
                <>
                  <div
                    className="commonintroduction-box-title"
                    onClick={() =>
                      navigate(`/post/${collectionName}/${item.id}`)
                    }
                  >
                    <span className="commonintroduction-box-title-text">
                      {item.title}
                    </span>

                    {isAdmin && (
                      <button
                        className="commonintroduction-box-edit-button"
                        onClick={() =>
                          navigate(`/firestoreservice/${item.id}/edit`, {
                            state: {
                              posttitle: postTitle,
                              databasename: collectionName,
                              targetitems: targetItems,
                              targetData: item,
                            },
                          })
                        }
                      >
                        ︙
                      </button>
                    )}
                  </div>

                  <div
                    className="commonintroduction-box-content"
                    onClick={() =>
                      linkMode === "external"
                        ? item.linkUrl && (window.location.href = item.linkUrl)
                        : navigate(`/post/${collectionName}/${item.id}`)
                    }
                  >
                    {item.image && (
                      <img
                        src={item.image}
                        className="commonintroduction-box-image"
                        alt=""
                      />
                    )}

                    {enableMarkdown ? (
                      <MarkdownPreview content={item.content} maxLength={58} />
                    ) : (
                      <span className="commonintroduction-box-content-text">
                        {item.content}
                      </span>
                    )}

                    {enableMarkdown && (
                      <div className="read-more">続きを読む...</div>
                    )}
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CommonIntroductionBase;
